<script setup lang="ts">
import type { CommandItemBaseProps } from "./types";
import { CodeIcon } from "lucide-vue-next";
import SuggestionListItem from "../suggestions/SuggestionListItem.vue";

const props = defineProps<CommandItemBaseProps>();

function run() {
  props.editor
    .chain()
    .focus()
    .deleteRange(props.range)
    .insertBelow(({ escapeList: true, onlyIfEmpty: true }))
    .toggleCodeBlock()
    .run();
}

defineExpose({ run });
</script>

<template>
  <SuggestionListItem
    :icon="CodeIcon"
    shortcut="```"
    @click="run"
    @keydown.enter="run"
  >
    Code block
  </SuggestionListItem>
</template>
